import Loadable from "components/Loadable";
import {lazy} from "react";
import SettingBase from "pages/setting/SettingBase";
const AccountsDashboard = Loadable(lazy(() => import('pages/reports/accounting')));
const ProjectReports = Loadable(lazy(() => import('pages/reports/project')));
const InvoiceReports = Loadable(lazy(() => import('pages/reports/invoice')));


const Reports = {
    path: 'reports',
    element: <SettingBase />,
    children: [
        {
            path: '',
            element: <AccountsDashboard />
        },
        {
            path: 'project',
            element: <ProjectReports />
        },
       
        {
            path: 'accounts',
            element: < AccountsDashboard/>
        },
        {
            path: 'invoice',
            element: < InvoiceReports/>
        },
       
    ]}
export default Reports;
